export default __webpack_public_path__ + "static/media/search-white.c2dd7677.svg";